/* eslint-disable no-param-reassign */
import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface Props {
	isNavigationOpened: boolean;
	setNavigationOpened: (opened: boolean) => void;
	isMobileApp: boolean;
	/**
	 * mobilni aplikace - android, ios zabalena aplikace, nejedna se o prohlizec
	 * @param isMobileApp
	 * @returns
	 */
	setIsMobileApp: (isMobileApp: boolean) => void;
}

export const useDeviceStore: UseBoundStore<StoreApi<Props>> = create(
	immer<Props>(set => ({
		isNavigationOpened: true,
		setNavigationOpened: opened => set({ isNavigationOpened: opened }),
		isMobileApp: false,
		setIsMobileApp: isMobileApp => set({ isMobileApp }),
	})),
);
